var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('highcharts',{ref:_vm.chartId,staticClass:"chart w-full h-full",attrs:{"options":_vm.options,"id":"chartId"}})}
var staticRenderFns = []

export { render, staticRenderFns }